<template>
    <div>
        <el-dialog title="留言管理" :visible.sync="msgDialog" width="80%" :close-on-click-modal="false">
            <div style="display: flex; justify-content: flex-end; align-items: center;">
                <!-- <el-input v-model="userName" style="width: 170px;" placeholder="请输入用户名"></el-input> -->
                <div>所属课程：</div>
                <el-dropdown class="mr-20" @command="courseChange">
                    <el-button type="primary">
                        选择课程<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(c, i) in courseList" :key="i" :command="c.courseId">
                            {{ c.courseTitle }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-dropdown class="mr-20" @command="periodChange">
                    <el-button type="primary">
                        按留言时间<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="10">最近10天</el-dropdown-item>
                        <el-dropdown-item :command="15">最近半个月</el-dropdown-item>
                        <el-dropdown-item :command="30">最近一个月</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>

                <el-button type="primary" @click="msgUpdataAll(1)" plain>批量公开</el-button>
                <el-button type="primary" @click="msgPopAll()" plain>批量置顶</el-button>
                <el-button type="danger" @click="msgUpdataAll(2)" plain>批量删除</el-button>
            </div>

            <dy-table :columns="columns" style="margin-top: 12px;" tableHeight="300" :table-data="msgList"
                v-loading="tableLoading" :total="total" :page-num="pageNum" :page-size="10" element-loading-text="加载中"
                @current-change="pageChange" @selection-change="onSelectionChange"></dy-table>
        </el-dialog>
        <el-dialog :visible.sync="addRemarkDialog" width="80%" :close-on-click-modal="false">
            <el-form>
                <el-form-item label="回复信息：">
                    <el-input style="width: 500px;" :rows="4" type="textarea" v-model="textRemark"
                        placeholder="请输入回复信息"></el-input>
                </el-form-item>
            </el-form>
            <div class="box box-align-center box-pack-end mt-btns" style="margin-top: 12px;margin-right: 30px;">
                <el-button type="primary" plain @click="addTextRemark()">发送</el-button>
                <el-button type="danger" plain @click="() => addRemarkDialog = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'

import { getTextMsg, addTextRemark, textMsgPop, getMsgCoursesList, textMsgUpdata } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
    name: "textMessage",
    components: {
        DyTable,
    },
    props: {


    },

    watch: {
        text(newArr, oldArr) {
            if (newArr && newArr.id) {
                this.search('refresh');
                this.getCourse();
            }
        }
    },
    data() {

        return {
            userName: "",
            courseId: "",
            period: null,
            searchForm: {
            },
            tableLoading: false,
            msgDialog: false,
            columns: [],
            msgList: [],

            pageNum: 1,
            pageSize: 10,
            total: 0,

            text: {},


            addRemarkDialog: false,
            textRemark: "",

            msg: {},
            courseList: [],

            selList: [],

        };
    },
    created() {
        this.columns = [
            {
                type: "selection",
                width: "55"
            },
            {
                type: 'index',
                title: '序号'
            },
            {
                key: 'createUserName',
                title: '用户名'
            },
            {
                key: 'content',
                title: '评论内容'
            },
            {
                key: 'courseName',
                title: '所属课程'
            },
            {
                key: 'status',
                title: '发表状态',
                width: 100,
                render: ({ row }) => {
                    return (
                        < div >
                            {row.status == 0 && ('未公开')}
                            {row.status == 1 && ('公开')}
                        </div >
                    );
                }
            },
            {
                key: 'topFlag',
                title: '是否置顶',
                width: 100,
                render: ({ row }) => {
                    return (
                        < div >
                            {row.topFlag && ('是')}
                            {!row.topFlag && ('否')}
                        </div >
                    );
                }
            },
            {
                key: 'createTime',
                title: '发表评论时间',
                width: 200,
                render: ({ row }) => {

                    return (
                        <div>{this.formatDate(row.createTime)}</div>
                    );
                }
            },
            {
                key: '',
                title: '操作',
                width: 300,
                render: ({ row }) => {
                    return (
                        <div>
                            {row.status == 0 && (
                                <el-link type="primary" style="margin-left:12px" onClick={() => this.textMsgUpdata(row, 1)}>公开</el-link>
                            )}
                            <el-link type="primary" style="margin-left:12px" onClick={() => this.textMsgPop(row)}>
                                {row.topFlag && ('取消')}置顶
                            </el-link>
                            <el-link type="primary" style="margin-left:12px" onClick={() => this.remarkDialogOpen(row)}>运营者回复</el-link>
                            <el-link type="danger" style="margin-left:12px" onClick={() => this.textMsgUpdata(row, 2)}>删除留言</el-link>
                        </div>
                    );
                },
            },
        ]
    },
    mounted() {
        // this.getList();
        // this.getCourse();
    },
    methods: {

        getCourse() {
            console.log('this.text :>> ', this.text);
            let info = {
                textId: this.text.id,
            };
            var data = encrypt(JSON.stringify(info));
            getMsgCoursesList(data).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));
                    this.courseList = ress;

                    console.log('resss :>> ', ress);
                } else {

                }
            });
        },

        // 将时间戳转换为字符串
        formatDate(timestamp) {
            if (!timestamp) return ''; // 处理无效值
            const date = new Date(timestamp * 1000); // 将秒级时间戳转换为毫秒级
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}年${month}月${day}日 ${hours}:${minutes}:${seconds}`;
        },
        msgDialogOpen(text) {
            this.text = text;
            this.msgDialog = true;
            this.search('refresh')
        },


        addTextRemark() {
            let info = {
                content: this.textRemark,
                courseId: this.msg.courseId,
                textId: this.msg.themeId,
                replyId: this.msg.id,
                parentId: this.msg.parentId,
            };

            addTextRemark(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: '回复成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        remarkDialogOpen(row) {
            this.textRemark = "";
            this.msg = row;
            this.addRemarkDialog = true;
        },
        onSelectionChange(arr) {
            this.selList = [...arr]
        },
        msgPopAll() {
            if (this.selList.length == 0) {
                this.$message({
                    showClose: true,
                    message: '请先选择留言',
                    type: 'warning',
                });
                return
            }
            let ids = this.selList.map(e => {
                return e.id
            })
            let info = {
                courseId: this.selList[0].courseId,
                textId: this.selList[0].themeId,
                ids: ids,
                topFlag: true
            };
            textMsgPop(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });

        },
        textMsgPop(msg) {
            let info = {
                courseId: msg.courseId,
                textId: msg.themeId,
                ids: [msg.id],
                topFlag: !msg.topFlag
            };

            textMsgPop(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });

        },
        msgUpdataAll(status) {
            if (this.selList.length == 0) {
                this.$message({
                    showClose: true,
                    message: '请先选择留言',
                    type: 'warning',
                });
                return
            }
            let ids = this.selList.map(e => {
                return e.id
            })
            let info = {
                courseId: this.selList[0].courseId,
                textId: this.selList[0].themeId,
                ids: ids,
                status: status,
            };
            textMsgUpdata(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        textMsgUpdata(msg, status) {
            let info = {
                courseId: msg.courseId,
                textId: msg.themeId,
                ids: [msg.id],
                status: status,
            };
            textMsgUpdata(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    this.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    this.getList();
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },

        courseChange(val) {
            this.courseId = val;
            this.search();
        },

        periodChange(val) {
            this.period = val;
            this.search();
        },
        search(msg) {
            this.pageNum = 1
            this.searchForm = {
                userName: this.userName,
                courseId: this.courseId,
                period: this.period || 0,
            }
            console.log('searchForm :>> ', this.searchForm);
            if (msg == "refresh") {
                this.searchForm = {};
                this.userName = ""
                this.courseId = ""
                this.period = null
            }
            this.getList()
        },


        getList(searchForm) {
            if (searchForm) {
                this.searchForm = searchForm;
            }
            this.tableLoading = true;
            let info = {
                page: this.pageNum,
                pageSize: this.pageSize,
                // textId: this.text.id,
                textId: this.text.id,
                // type: 0,
                ...this.searchForm
            };

            getTextMsg(encrypt(JSON.stringify(info))).then((res) => {
                if (res.result == 1) {
                    var ress = JSON.parse(decrypt(res.data));

                    console.log('ress :>> ', ress);
                    this.msgList = ress.content;

                    this.total = ress.totalElements;
                    this.tableLoading = false;
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        // 分页
        pageChange(val) {
            console.log('val :>> ', val);
            this.pageNum = val;
            this.getList();
        },
    }
};
</script>
<style scoped>

.mr-20 {
    margin-right: 20px;
}
</style>